import Splide from '@splidejs/splide';

export default () => {
  new Splide('.testimonial-slider_splide.splide', {
    type: 'fade',
    arrows: false,
    pagination: false,
    autoplay: true,
    rewind: true,
    interval: 5000,
    speed: 1000,
  }).mount();
};
